/**
 * Determina o tipo de veículo baseado no chassi
 * 
 * Regras:
 * - Caminhão: chassi começa com "95"
 * - Ônibus: chassi contém "TB" ou "TU"
 * - Carreta: chassi começa com "9A" ou "94"
 * - Carro: chassi começa com "9B"
 * - Padrão: caminhão (fallback)
 */
export type VehicleType = 'truck' | 'bus' | 'trailer' | 'car';

export const getVehicleTypeByChasis = (chassis: string | undefined): VehicleType => {
    if (!chassis) return 'truck'; // fallback padrão

    const chassisUpper = chassis.toUpperCase().trim();

    // Ônibus: contém TB ou TU
    if (chassisUpper.includes('TB') || chassisUpper.includes('TU')) {
        return 'bus';
    }

    // Carro: começa com 9B
    if (chassisUpper.startsWith('9B')) {
        return 'car';
    }

    // Carreta: começa com 9A ou 94
    if (chassisUpper.startsWith('9A') || chassisUpper.startsWith('94')) {
        return 'trailer';
    }

    // Caminhão: começa com 95
    if (chassisUpper.startsWith('95')) {
        return 'truck';
    }

    // Fallback padrão
    return 'truck';
};

export const getVehicleIconClass = (vehicleType: VehicleType): string => {
    const iconMap: Record<VehicleType, string> = {
        truck: 'rioglyph-truck',
        bus: 'rioglyph-bus',
        trailer: 'rioglyph-trailer',
        car: 'rioglyph-car',
    };
    return iconMap[vehicleType];
};

